import { useTranslation } from 'react-i18next'

const Route401 = () => {
  const { t } = useTranslation()
  const errorMessage = t('global.page_not_found')

  return <div>{errorMessage}</div>
}

export default Route401
